<input type="checkbox" [attr.id]="forId" [ngModel]="checked" (ngModelChange)="emitChange($event)" [disabled]="disabled" />
<div class="kui-toggle" [class.disabled]="disabled"></div>
